import { render, staticRenderFns } from "./ResourceEmployees.vue?vue&type=template&id=08b866ea&scoped=true&"
import script from "./ResourceEmployees.vue?vue&type=script&lang=js&"
export * from "./ResourceEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEmployees.vue?vue&type=style&index=0&id=08b866ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b866ea",
  null
  
)

export default component.exports